<script>
import IntSidebar from './sidebar'

export default {
  components: { IntSidebar },
  props: ['staticMenu'],
  data: () => ({
    active: false
  }),
  computed: {
    switchBar: {
      get () {
        return this.staticMenu
      },
      set (val) {
        this.monitorarSwitch(val)
      }
    }
  },
  methods: {
    monitorarSwitch (val) {
      this.$emit('monitorarSwitch', val)
    },
    menu () {
      if (this.active === false) this.active = true
      else this.active = false
    },
    ocultarMenu () {
      this.active = false
    }
  }
}
</script>

<template>
  <div>
    <div class="header-container fs-topbar">
      <div class="header">
        <v-toolbar dark color="primary">
          <h4>
            <span>&nbsp;&nbsp;</span>
            <v-icon>account_balance</v-icon>Farsoft ERP
          </h4>
          <vs-switch v-model="switchBar" vs-color="#DE5433" style="margin-left: auto; margin-right: 10px;" >
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>

          <v-tooltip bottom v-show="!switchBar">
            <v-btn icon slot="activator" color="primary" dark @click="menu()">
              <v-icon>menu</v-icon>
            </v-btn>
            <span>Mostrar/Ocultar Menu</span>
          </v-tooltip>
        </v-toolbar>
      </div>
    </div>
    <int-sidebar :activeMenu='active' @ocultarMenu="ocultarMenu" :staticMenu='staticMenu' @monitorarSwitch="monitorarSwitch" />
  </div>
</template>
